import React from 'react'
import { Box, Text } from '@chakra-ui/react'
import pluralize from 'pluralize'

interface Props {
    item: string
}

export default function InfoEmptyPlaceholder({ item }: Props) {
    return (
        <Box w="full" bg="gray.50" px={4} py={3} rounded="xl">
            <Text fontWeight="semibold" color="gray.600" fontSize="sm">
                No {pluralize(item, 0)} found
            </Text>
            <Text fontSize="xs" color="gray.500">
                There were no {pluralize(item, 0)} returned at this time.
            </Text>
        </Box>
    )
}
